import React from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import WarningFlag from '@atlassian/jira-flags/src/common/ui/components/warning-flag'; // ignore-for-ENGHEALTH-17759
import { useIntl } from '@atlassian/jira-intl';
import { useQueryParam } from '@atlassian/jira-software-router-utils/src/services/query-param/index.tsx';
import { isWorkTypeAvgLength } from '@atlassian/jira-providers-issue/src/utils.tsx';
import { QUERY_PARAM_SELECTED_ISSUE } from '../../model/routing/constants.tsx';
import type { Card } from '../../model/types.tsx';
import flagMessages from './messages.tsx';

export type Props = {
	id: string;
	card: Card;
	onPrimaryActionClick: (flagId: string) => void;
};

const CardIsFiltered = ({ onPrimaryActionClick, card, ...props }: Props) => {
	const { formatMessage } = useIntl();
	const [, setIssueKey] = useQueryParam(QUERY_PARAM_SELECTED_ISSUE);
	const workType = card.issueTypeName;

	const getCreatedCardLink = () => {
		if (
			workType &&
			isWorkTypeAvgLength(workType) &&
			expVal('jira-itr-work-type-exp-1', 'isEnabled', false)
		) {
			return flagMessages.createdCardIsFilteredLinkIssueTerminologyRefreshM4;
		}
		if (expVal('issue-terminology-refresh-m2-replace', 'isEnabled', false)) {
			return flagMessages.createdCardIsFilteredLinkIssueTermRefresh;
		}
		return flagMessages.createdCardIsFilteredLink;
	};

	return (
		<WarningFlag
			messageId="software-backlog.flags.card-create-filtered.warning-flag"
			messageType="transactional"
			{...props}
			key={card.key}
			title={formatMessage(flagMessages.createdCardIsFilteredTitle, {
				cardKey: card.key,
			})}
			description={formatMessage(flagMessages.createdCardIsFilteredDescription)}
			actions={[
				{
					content: formatMessage(getCreatedCardLink(), { workType: card.issueTypeName }),
					onClick: () => {
						onPrimaryActionClick(String(card.id));
						setIssueKey(card.key);
					},
				},
			]}
		/>
	);
};
export default CardIsFiltered;
